import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { d as defineCustomElement$4 } from './p-5313e3e6.js';
import { d as defineCustomElement$3 } from './p-39e08a11.js';
import { d as defineCustomElement$2 } from './p-85a1378f.js';

const biNotificationCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{display:block;width:100%}.notification{display:grid;border-radius:4px;min-width:256px;max-width:720px;padding:16px 24px;display:grid;gap:16px;grid-template-columns:30px 1fr 30px;grid-template-areas:\"icon-column content close-column\";font-family:\"museo-sans\", arial, sans-serif, sans-serif;font-style:normal;color:#414651}.notification.hidden{display:none}.notification .icon-column{grid-area:icon-column}.notification .close-column{grid-area:close-column;display:flex;justify-content:flex-end;height:42px}.notification .close-column .link{cursor:pointer;height:24px}.notification .content{grid-area:content;display:flex;flex-direction:column;gap:16px}.notification .title{font-size:1.25rem;font-weight:600;line-height:1.5}.notification .message{font-size:1rem;font-weight:400;line-height:1.5}.notification.red{background-color:#fff2f2;border:1px solid #8c0a08}.notification.green{background-color:honeydew;border:1px solid #05630a}.notification.yellow{background-color:#fff7e3;border:1px solid #cca543}.notification.blue{background-color:#cfebff;border:1px solid #01417b}";
const BiNotificationStyle0 = biNotificationCss;

const BiNotification$1 = /*@__PURE__*/ proxyCustomElement(class BiNotification extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * The color of the notification.
         * Can be one of 'red', 'yellow', 'blue', or 'green'.
         * Defaults to 'green'.
         */
        this.color = 'green';
        /**
         * Whether to hide the close button.
         * Defaults to false.
         */
        this.hideCloseButton = false;
        this.hidden = false;
    }
    close() {
        this.hidden = !this.hidden;
    }
    render() {
        const Icon = `bi-icon-${this.icon}`;
        const className = `notification ${this.color} ${this.hidden ? ' hidden' : ''}`;
        const ariaLabelClose = this.closeAreaLabel !== undefined ? this.closeAreaLabel : 'Close button';
        return (h(Host, { key: '1c28154ff4fc80048bce26103fcc81da8157da53' }, h("div", { key: '2e05302f57a849d271499cb3bc96d871fd73da12', class: className }, h("div", { key: '9ae1eb718d10d7519f2bc43049ee798f58a1062d', class: 'icon-column' }, h(Icon, { key: '9009f8a206091f990d2b766fc2181a4300eeea9e', size: 'large', color: 'black', "aria-hidden": 'true' })), h("div", { key: '84869aaa26f844a45e59c90862a0498aab70d7cb', class: 'content' }, h("div", { key: 'fad8fd44dc0a86f137644680ec3b674d4029a216', class: 'title' }, this.heading), h("div", { key: '48be92ae737f201949d1f764c7534709bf049d04', class: 'message' }, this.message), h("slot", { key: 'cdee9985bc525ad067e0159b4fea483aa8bd719f' })), !this.hideCloseButton && (h("div", { key: 'e4ae2d8ded0f5962221df5b1d1cc27b8c44f9da3', class: 'close-column' }, h("bi-button", { key: '380e0faaabc46d90ce68106a22e6691102b0cbc4', variant: 'text', icon: true, size: 'medium', "aria-label": ariaLabelClose, onClick: () => this.close() }, h("bi-icon-cross", { key: 'b196fd9bb4c2eccd1344c9d66aacd3ac1a9b4e45', size: 'medium', color: 'black', "aria-hidden": 'true' })))))));
    }
    static get style() { return BiNotificationStyle0; }
}, [1, "bi-notification", {
        "icon": [1],
        "color": [1],
        "heading": [1],
        "message": [1],
        "notificationIconAreaLabel": [1, "notification-icon-area-label"],
        "closeAreaLabel": [1, "close-area-label"],
        "hideCloseButton": [4, "hide-close-button"],
        "hidden": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-notification", "bi-button", "bi-icon-cross", "bi-spinner"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-notification":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiNotification$1);
            }
            break;
        case "bi-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "bi-icon-cross":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "bi-spinner":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BiNotification = BiNotification$1;
const defineCustomElement = defineCustomElement$1;

export { BiNotification, defineCustomElement };
